import { UIElement } from '../ui-element';
import { Component } from '../../decorators/component.decorator';
import { CMS_CONTENT_MODES } from '../../cms';
import styles from './ui-column.css';

/**
 * @class
 * @memberof SharedComponents
 * @augments {UIElement}
 * @alias UIColumn
 * @element ui-column
 * @property {number} span {@attr span} Spans the column, acts as flex value.
 * @classdesc Represents a class for <code>ui-column</code> element.
 * Layout column should be column child of ui-columns.
 * @slot
 * @example
 * <ui-column></ui-column>
 */
@Component({
    tag: 'ui-column',
    styles,
    cms: { mode: CMS_CONTENT_MODES.Children },
})
export class UIColumn extends UIElement {}
